const initState = {
  loading: false,
  subscriptionData: null,
  couponData: {},
};
const subscriptionReducer = (state = initState, action) => {
  switch (action.type) {
    case "COUPON_LOADER":
      return {
        ...state,
        loading: action.payload,
      };
    case "SETCOUPON":
      return {
        ...state,
        couponData: action.payload,
      };
    case "GET_SUBSCRIPTION":
      return {
        ...state,
        subscriptionData: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default subscriptionReducer;
